function isSameDay(a: Date, b: Date): boolean {
    return (
        a.getFullYear() === b.getFullYear() &&
        a.getMonth() === b.getMonth() &&
        a.getDate() === b.getDate()
    );
}

export function formatChatDate(input: Date | string | number): string {
    const date = input instanceof Date ? input : new Date(input);
    const now = new Date();

    const yesterday = new Date();
    yesterday.setDate(now.getDate() - 1);

    const time = date.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
    });

    if (isSameDay(date, now)) {
        return time;
    }

    if (isSameDay(date, yesterday)) {
        return `Yesterday, ${time}`;
    }

    const month = date.toLocaleString("en-US", { month: "long" });
    const day = date.getDate();

    return `${month} ${day}, ${time}`;
}